// Import model
import { LeadIntegration } from '../models/LeadIntegration';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadIntegration - handles JSON serialization and deserialization with type validation
 */
export class LeadIntegrationSerializer {
  /**
   * Deserializes a JSON string into a LeadIntegration instance
   */
  static deserialize(json: string): LeadIntegration {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadIntegration instance
   */
  static fromObject(obj: any): LeadIntegration {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadIntegration');
    }


    const instance: LeadIntegration = {
      tag: obj['tag'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      status: obj['status'] as string | undefined,
      url: obj['url'] as string | undefined,
      integrationId: obj['integrationId'] as string | undefined,
      integrationIdName: obj['integrationId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadIntegration instances
   */
  static deserializeArray(json: string): LeadIntegration[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadIntegration instance to a JSON string
   */
  static serialize(instance: LeadIntegration): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadIntegration instance to a plain object
   */
  static toObject(instance: LeadIntegration): any {
    return {
      'tag': instance.tag,
      'externalId': instance.externalId,
      'status': instance.status,
      'url': instance.url,
      'integrationId': instance.integrationId,
      'integrationId|Name': instance.integrationIdName,
    };
  }

  /**
   * Serializes an array of LeadIntegration instances to a JSON string
   */
  static serializeArray(instances: LeadIntegration[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
